<script>
    import terminoProjetoServico from '../servico';

    import $ from 'jquery';
    import 'select2';
    import 'select2/dist/js/i18n/pt-BR';

    export default {
      components: {},
      data() {
        return {
          projetos: [],
          carregando: true,
          animated: true,
          configuracao: this.$storage.configuracao(),
          usuario: this.$storage.usuario(),
        }
      },
      computed: {
      },
      methods: {
        lista(pagina = 1) {
          this.carregando = true;

          return terminoProjetoServico.lista(pagina, this.filtros)
            .then(res => {
              this.carregando = false;
              this.projetos = res.body;
            });
        },
      },
      created() {
        this.$root.botaoAcaoMostrar = false;
        this.$root.botaoRetrocederMostrar = false;
      },
      mounted() {
        this.$root.botaoAcaoMostrar = false;
        this.$root.botaoRetrocederMostrar = false;
        this.$root.tituloDaPagina = 'Projetos Terminando - Lista';

        this.lista();

        const _this = this;
      },
      watch: {

      },
    }
</script>

<template>

    <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">
        <div class="row">
            <div class="col-lg-12">
                <div class="ibox collapsed float-e-margins">
                    <div class="ibox-footer" v-if="projetos.length > 0">
                        <div class="table-responsive">
                            <table class="table table-bordered table-column-code table-column-action">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Projeto</th>
                                        <th>Coordenador</th>
                                        <th>Data Início</th>
                                        <th>Data Término</th>
                                        <th>Dias para término</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(projeto, index) in projetos">
                                        <td></td>
                                        <td class="text-left">{{ projeto.nomeProjeto || '---' }}</td>
                                        <td>{{ projeto.coordenador || '---' }}</td>
                                        <td>{{ projeto.dataInicio || '---' }}</td>
                                        <td>{{ projeto.dataTermino || '---' }}</td>
                                        <td>{{ projeto.diasTermino == 0 ? 'Termina hoje': 'Termina daqui ' + projeto.diasTermino + ' dia(s)'}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="ibox-footer" v-if="projetos.length == 0 && !carregando">
                        <div class="group">
                            <h4 class="text-center">Sem projetos terminando</h4>
                        </div>
                    </div>

                    <div class="ibox-footer" v-if="carregando">
                        <div class="group">
                            <p class="text-center">
                                <i class='fa fa-spinner fa-pulse'></i> Carregando...
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/projetos-termino/componentes/TerminoProjetoLista.vue